/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclEntryGlobal extends models.DashboardDefinitionAclEntry {
    constructor() {
        super();
        this.setDiscriminator("global");
    }

    getFixupPrototypeFunction() { return DashboardDefinitionAclEntryGlobal.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclEntryGlobal>): DashboardDefinitionAclEntryGlobal {
        let obj = Object.assign(new DashboardDefinitionAclEntryGlobal(), model);
        DashboardDefinitionAclEntryGlobal.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclEntryGlobal>): DashboardDefinitionAclEntryGlobal {
        if (!model) return null;
        return DashboardDefinitionAclEntryGlobal.newInstance(<DashboardDefinitionAclEntryGlobal> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclEntryGlobal) {
        if (!obj) return;

        models.DashboardDefinitionAclEntryGlobal.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclEntryGlobal): boolean {
        if (models.DashboardDefinitionAclEntry.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DashboardDefinitionAclEntryGlobal.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.role_types) {
            for (let val of this.role_types) {
                models.DashboardDefinitionAclRoleType.fixupPrototype(val);
            }
        }
    }

    role_types: Array<models.DashboardDefinitionAclRoleType>;

}
